import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import Footer from '../../../../Layout/Footer';
import Header from '../../../../Layout/Header';
import { FaRupeeSign } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import MultiRangeSlider from "multi-range-slider-react";
import { Card } from 'react-bootstrap';
import { BiTimeFive } from 'react-icons/bi';
import { BsGlobe } from 'react-icons/bs';
import { AiOutlineCalendar } from 'react-icons/ai';
import taskimage from '../../../../../assets/img/taskimg.png';
import Logo from '../../../../../assets/img/logo.png';
import Modal from 'react-bootstrap/Modal';
import postTask from '../../../../../assets/img/taskPost.png';
import { getMakeAnOffer } from '../../../../../Redux/Task/action';


const LogoDesigningDetail = () => {

    const [minValue, set_minValue] = useState(25);
    const [maxValue, set_maxValue] = useState(75);
    const handleInput = (e) => {
        set_minValue(e.minValue);
        set_maxValue(e.maxValue);
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [switchbutton, setSwitchbutton] = useState(false);
    const checkRemote = (e) => {
        setSwitchbutton(true);
    }

    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Logo Designing</h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Logo Designing</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='logodesign-details'>
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-md-4 col-lg-3 sidebar-filter">
                            <Form id='filterForm'>
                                <div className='logodesign-details-filter mb-4'>
                                    <h3 className="mt-0 mb-3">Filters</h3>
                                    <h4 className="mt-0 mb-3" role="button">CLEAR ALL</h4>
                                </div>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Control type="text" name='search' placeholder="Search key" />
                                </Form.Group>
                                <Form.Select aria-label="Default select example" name='category' className="mb-3">
                                    <option value=''>Choose category</option>
                                </Form.Select>
                                <Form.Select aria-label="Default select example" name='sort' className="mb-3">
                                    <option value=''>Sort</option>

                                </Form.Select>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Price Range</Form.Label>
                                    <div className='range-value'>{minValue} <FaRupeeSign size={16} /> - {maxValue} <FaRupeeSign size={16} /></div>
                                    <MultiRangeSlider
                                        className='multi-price-ranger'
                                        min={0}
                                        max={10000}
                                        step={5}
                                        minValue={minValue}
                                        maxValue={maxValue}
                                        ruler={false}
                                        barInnerColor={"#012970"}
                                        onInput={(e) => {
                                            handleInput(e);
                                        }}
                                    />
                                </Form.Group>

                                <div className='filter-btn mt-4'>
                                    <button type="submit" className="btn btn-primary mb-4">Apply Filter</button>
                                </div>


                            </Form>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <div className='logodesign-details-rightblock'>
                                <section className='browse-tasks'>
                                    <div className='container'>
                                        <div className='row'>
                                            <div className='col-lg-12'>
                                                <div className='browse-tasks-tasks p-0 m-0'>
                                                    <div className='row'>
                                                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                                            <Link className='browse-task-link' to=''>
                                                                <Card style={{ height: "auto" }}>
                                                                    <Card.Body>
                                                                        <div className='tasks-title'>
                                                                            <Card.Title>
                                                                                Logo Designing
                                                                                <div>
                                                                                    <img src={Logo} alt='Logo' className='img-fluid' />
                                                                                </div>
                                                                            </Card.Title>

                                                                            <div className='make-an-offer'>
                                                                                <div className='make-an-offer-head'>
                                                                                    Task Budget
                                                                                </div>
                                                                                <h6><FaRupeeSign size={26} /> 60</h6>
                                                                                <div className='browsetask-btn'>
                                                                                    <Button type="submit" className="btn btn-primary" onClick={handleShow}>Make an offer</Button>
                                                                                </div>
                                                                                <Modal
                                                                                    className='make-an-offer-modal'
                                                                                    show={show}
                                                                                    onHide={handleClose}
                                                                                    backdrop="static"
                                                                                    keyboard={false}
                                                                                    centered
                                                                                >
                                                                                    <Modal.Header closeButton>

                                                                                    </Modal.Header>
                                                                                    <Modal.Body>
                                                                                        <Form>

                                                                                            {switchbutton ?
                                                                                                <React.Fragment>
                                                                                                    <div className="contain">
                                                                                                        <div className="done">
                                                                                                            <img src={postTask} alt='Congratulations' className="img-fluid" />
                                                                                                        </div>
                                                                                                        <div className="congrats">
                                                                                                            <h1>Offer Made</h1>
                                                                                                            <p className="regards">Congratulations, you have made an offer for a Task. we will update ypu the progress about this offer via SMA/ notification. Thank you fro being an active user of Taskde</p>
                                                                                                        </div>
                                                                                                        <Button className='continue-btn' variant="secondary" onClick={handleClose}>
                                                                                                            Go
                                                                                                        </Button>
                                                                                                    </div>
                                                                                                </React.Fragment>

                                                                                                :
                                                                                                <React.Fragment>
                                                                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                                                                        <Form.Label>Type of offer</Form.Label>
                                                                                                        <Form.Select aria-label="Default select example">
                                                                                                            <option>Bid</option>
                                                                                                            {/* <option value="1">One</option>
                                                                                               <option value="2">Two</option>
                                                                                               <option value="3">Three</option> */}
                                                                                                        </Form.Select>
                                                                                                    </Form.Group>

                                                                                                    <Form.Group className="mb-3" controlId="formBasicPassword">
                                                                                                        <Form.Label>Experience</Form.Label>
                                                                                                        <Form.Control type="text" placeholder="Enter your experience in years" />
                                                                                                    </Form.Group>
                                                                                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                                                                                        <Form.Label>Example textarea</Form.Label>
                                                                                                        <Form.Control as="textarea" rows={3} />
                                                                                                    </Form.Group>
                                                                                                    <div className='text-center'>
                                                                                                        <Button className='continue-btn' variant="secondary" onClick={checkRemote}>
                                                                                                            Continue
                                                                                                        </Button>
                                                                                                    </div>

                                                                                                </React.Fragment>
                                                                                            }
                                                                                            {/* <div className='text-center'>
                                                                                                <Button className='continue-btn' variant="secondary" onClick={checkRemote}>
                                                                                                    Continue
                                                                                                </Button>
                                                                                            </div> */}

                                                                                        </Form>

                                                                                    </Modal.Body>
                                                                                </Modal>
                                                                            </div>
                                                                        </div>
                                                                        <div className='card-text tasks-browser-border'>
                                                                            <div className='row'>
                                                                                <div className='col-lg-6'>
                                                                                    <div className='tasks-browse pt-2'>
                                                                                        <BsGlobe className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                                        <p>Remote</p>
                                                                                    </div>
                                                                                    <div className='tasks-browse pt-1'>
                                                                                        <BiTimeFive className='ms-2' style={{ color: "#012970" }} />
                                                                                        <p>Thu, 2 Feb</p>
                                                                                    </div>
                                                                                    <div className='tasks-browse pt-1 mb-2'>
                                                                                        <AiOutlineCalendar className='ms-2' title='website' style={{ color: "#012970" }} />
                                                                                        <p>Morning</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='col-lg-6'>
                                                                                    <div className='tasks-browser-img'>
                                                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className='task-time-browse mt-4'>
                                                                                <h6>Details</h6>
                                                                                <p className='task-details'>Help logo designing. Active Campaign, mailchimp, etc. I provide content and you help refine them. Target Australia B2B  small biz decision maker. Do you know where to buy good email list?</p>
                                                                                <p><span><strong>*</strong></span>Due date: Needs to be done on Saturday, 10 December 2022</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='card-text'>
                                                                            <div className='browsetask-btn mt-4'>
                                                                                <Link type="submit" className="btn btn-primary" to='/signup'>Join Taskde</Link>
                                                                                <p>Or</p>
                                                                            </div>
                                                                            <div className='request-quote'>
                                                                                <Link className="request-quote-btn" to="/signin">Log in</Link>
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                    <div className='row mt-3'>
                                                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </div>
                </div>
            </section >
            <Footer />
        </React.Fragment >
    )
}

export default LogoDesigningDetail;